// extracted by mini-css-extract-plugin
export default {"container":"FileUploaderModal_container__YmHQj","text":"FileUploaderModal_text__BTZ-V","subtext":"FileUploaderModal_subtext__38ofG"};